import { useEffect, useRef, useState } from 'react';

const useIsVisible = (initialState: boolean = false) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [isReady, setIsReady] = useState(false);

    const [isViewable, setIsViewable] = useState(initialState);
    const [wasViewable, setWasViewable] = useState(initialState);
    const isMounted = !!containerRef.current;

    useEffect(() => {
        setTimeout(() => setIsReady(true), 0);
    }, [setIsReady]);

    useEffect(() => {
        if (!isReady) return;
        const container = containerRef.current;
        if (!container) return;

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setIsViewable(true);
                        setWasViewable(true);
                    } else {
                        setIsViewable(false);
                    }
                });
            },
            { threshold: 0.1, root: null, rootMargin: '50% 0px' },
        );

        observer.observe(container);

        return () => {
            observer.disconnect();
        };
    }, [isReady, setIsViewable, isMounted]);

    return { containerRef, isViewable, wasViewable };
};

export { useIsVisible };
